import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import OrganizationAppResource from './OrganizationAppResource';
import UserAppResource from './UserAppResource';
import MLSAppResource from './MLSAppResource';
import PlaybookAppResource from './PlaybookAppResource';
import Engine from '@milestoneslabs/milestones-js-engine';
import isEmpty from 'lodash/isEmpty';
import LuCommunicationContextAppResource from "./LuCommunicationContextAppResource";

class HubImportTokenAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Hub-Import-Token';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'hubs/imports/tokens';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'organizationUuid',
            'mlsUuid',
            'playbookUuid',
            'reportEmail',
            'name',
            'active',
            'proCommunications',
            'invitationType',
            'lookupCommunicationContextUuid',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            organization:             OrganizationAppResource,
            mls:                      MLSAppResource,
            playbook:                 PlaybookAppResource,
            reporterUser:             UserAppResource,
            lookupCommunicationContext: LuCommunicationContextAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            organization: 'organization_uuid',
            mls: 'mls_uuid',
            playbook: 'playbook_uuid',
            reporterUser: 'report_email',
            lookupCommunicationContext: 'lookup_communication_context_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            organizationUuid: {
                type: 'string',
                presence: true,
            },
            mlsUuid: {
                type: 'string',
                presence: false,
            },
            playbookUuid: {
                type: 'string',
                presence: true,
            },
            reportEmail: {
                type: 'string',
                presence: true,
            },
            active: {
                type: 'boolean',
            },
            proCommunications: {
                type: 'string',
            },
            invitationType: {
                type: 'string',
            },
            lookupCommunicationContextUuid: {
                type: 'string',
            },
        }
    }

    apiPaths(environment = null) {
        return {
            ...super.apiPaths(),
            refresh: Engine.apiUrl(this.appResourceApiPrefix() + '/{uuid}/refresh', environment),
        };
    }

    async refresh() {
        if (this.uuid === null) {
            return Promise.resolve(null)
        }

        const url = this.apiPaths().refresh.replace('{uuid}', this.uuid);
        const apiResponse = await Engine.get(url);

        if (isEmpty(apiResponse.resources) ||
            !apiResponse.resources.has(this.uuid)) {
            return Promise.resolve(null)
        }

        this.syncFromRemoteAppResource(apiResponse.resources.get(this.uuid))

        return apiResponse;
    }
}

export default HubImportTokenAppResource;
